// extracted by mini-css-extract-plugin
module.exports = {"block":"chartSales_block__ycVQu","not_found":"chartSales_not_found__KX0qi"};